import { render, staticRenderFns } from "./PlusSolidIcon.vue?vue&type=template&id=1cac7e15&"
import script from "./PlusSolidIcon.vue?vue&type=script&lang=js&"
export * from "./PlusSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports